import React from "react";
import { Box } from "@chakra-ui/react";

export const PortalBackground: React.FC = () => {
  return (
    <Box
      position="absolute"
      top="0"
      left="0"
      width="100%"
      height="100%"
      overflow="hidden"
      zIndex="0"
      pointerEvents="none"
    >
      {/* Deep mystical gradient base - pink tones */}
      <Box
        position="absolute"
        width="100%"
        height="100%"
        background="linear-gradient(180deg, #2e0a2a 0%, #4e1b45 30%, #3a0f35 60%, #200618 100%)"
      />

      {/* Swirling portal effect in center */}
      <Box
        className="portal-vortex"
        position="absolute"
        top="50%"
        left="50%"
        transform="translate(-50%, -50%)"
        width="300px"
        height="300px"
        borderRadius="50%"
        background="radial-gradient(ellipse, rgba(255,100,180,0.15) 0%, rgba(200,50,120,0.1) 30%, transparent 70%)"
        boxShadow="0 0 100px 50px rgba(220,80,150,0.1)"
      />

      {/* Ambient glow spots - pink tones */}
      <Box
        className="glow-spot-1"
        position="absolute"
        top="20%"
        left="15%"
        width="200px"
        height="200px"
        borderRadius="50%"
        background="radial-gradient(circle, rgba(255,100,150,0.25) 0%, transparent 70%)"
      />
      <Box
        className="glow-spot-2"
        position="absolute"
        top="60%"
        right="10%"
        width="250px"
        height="250px"
        borderRadius="50%"
        background="radial-gradient(circle, rgba(255,150,200,0.2) 0%, transparent 70%)"
      />
      <Box
        className="glow-spot-3"
        position="absolute"
        bottom="15%"
        left="25%"
        width="180px"
        height="180px"
        borderRadius="50%"
        background="radial-gradient(circle, rgba(255,120,180,0.22) 0%, transparent 70%)"
      />

      {/* Floating crystals/orbs - pink tones */}
      <Box className="crystals" position="absolute" width="100%" height="100%" top="0" left="0">
        {[...Array(8)].map((_, i) => (
          <Box
            key={i}
            className={`crystal crystal-${i + 1}`}
            position="absolute"
            width={12 + (i % 3) * 6 + "px"}
            height={18 + (i % 3) * 8 + "px"}
            background={`linear-gradient(135deg,
              rgba(255,${100 + i * 15},${180 + i * 10},0.8) 0%,
              rgba(200,${50 + i * 10},${120 + i * 8},0.6) 50%,
              rgba(150,${30 + i * 8},${80 + i * 5},0.4) 100%)`}
            borderRadius="2px 2px 50% 50%"
            boxShadow={`0 0 ${10 + i * 2}px rgba(255,120,180,0.5)`}
            opacity="0"
          />
        ))}
      </Box>

      {/* Magic particles - pink tones */}
      <Box className="magic-particles" position="absolute" width="100%" height="100%" top="0" left="0">
        {[...Array(15)].map((_, i) => (
          <Box
            key={i}
            className={`magic-particle magic-particle-${i + 1}`}
            position="absolute"
            width={3 + (i % 2) * 2 + "px"}
            height={3 + (i % 2) * 2 + "px"}
            borderRadius="50%"
            backgroundColor={i % 3 === 0 ? "#ff9ec4" : i % 3 === 1 ? "#ffb8d9" : "#ff7eb3"}
            boxShadow={`0 0 ${6 + i % 3 * 2}px ${i % 3 === 0 ? "#ff9ec4" : i % 3 === 1 ? "#ffb8d9" : "#ff7eb3"}`}
            opacity="0"
          />
        ))}
      </Box>

      {/* Mystical stars */}
      <Box className="portal-stars" position="absolute" width="100%" height="100%" top="0" left="0" />

      {/* Ethereal wisps */}
      <svg
        className="wisps-svg"
        viewBox="0 0 1440 800"
        preserveAspectRatio="none"
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          opacity: 0.4,
        }}
      >
        <defs>
          <linearGradient id="wispGrad1" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="transparent" />
            <stop offset="50%" stopColor="#ff66a3" stopOpacity="0.5" />
            <stop offset="100%" stopColor="transparent" />
          </linearGradient>
          <linearGradient id="wispGrad2" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="transparent" />
            <stop offset="50%" stopColor="#ff99cc" stopOpacity="0.4" />
            <stop offset="100%" stopColor="transparent" />
          </linearGradient>
          <linearGradient id="wispGrad3" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="transparent" />
            <stop offset="50%" stopColor="#ff80b3" stopOpacity="0.35" />
            <stop offset="100%" stopColor="transparent" />
          </linearGradient>
        </defs>

        <path
          className="wisp wisp-1"
          fill="none"
          stroke="url(#wispGrad1)"
          strokeWidth="3"
          d="M-100,200 Q200,150 400,250 Q600,350 800,200 Q1000,50 1200,180 Q1400,310 1540,200"
        />
        <path
          className="wisp wisp-2"
          fill="none"
          stroke="url(#wispGrad2)"
          strokeWidth="2"
          d="M-100,500 Q150,400 350,500 Q550,600 750,450 Q950,300 1150,480 Q1350,660 1540,500"
        />
        <path
          className="wisp wisp-3"
          fill="none"
          stroke="url(#wispGrad3)"
          strokeWidth="2.5"
          d="M-100,650 Q200,580 400,700 Q600,820 800,650 Q1000,480 1200,620 Q1400,760 1540,650"
        />
      </svg>
    </Box>
  );
};

export default PortalBackground;
